import React from "react";

const WhatsappIcon = () => {
  return (
    <>
      <div className="whatsapp_float" style={{height:"60px", width:"60px"}}>
        <a href="https://wa.me/+919174282618" target="_blank">
          <img
            src="./WhatsappLogo_1.gif"
            width="50px"
            className="whatsapp_float_btn"
            style={{height:"60px", width:"60px"}}
          />
        </a>

      </div>
    </>
  );
};

export default WhatsappIcon;
